module.exports = __webpack_public_path__ + "img/project-4.44bd99bc.jpg";